import * as yup from 'yup';
import { DateTime } from 'luxon';

export const TaskSchemaGenerator = () =>
  yup.object({
    description: yup.string().required(),
    dueDate: yup
      .string()
      .test(
        'my-date-test',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    // Role is required for task creation and editing
    role: yup.string().nullable().required('Role is required'),
    completedAt: yup
      .string()
      .test(
        'my-date-test',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    teammate: yup.string().notRequired(),
    completedBy: yup
      .object({
        id: yup.string().required(),
        fullName: yup.string().required(),
        email: yup.string().required(),
      })
      .default(undefined)
      .notRequired(),
  });

export const EditTaskSchemaGenerator = () =>
  yup.object({
    dueDate: yup
      .string()
      .test(
        'due-date-test',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    // Role is required for task creation and editing
    role: yup.string().nullable().required('Role is required'),
    teammate: yup
      .object({
        id: yup.string().required(),
        fullName: yup.string().required(),
        email: yup.string().required(),
      })
      .default(undefined)
      .notRequired()
      .nullable(),
  });

export const EditCompletedTaskSchemaGenerator = () =>
  yup.object({
    completedAtDate: yup
      .string()
      .test(
        'completed-at-date-test',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable()
      .notRequired(),
    completedAtTime: yup
      .string()
      .test(
        'completed-at-time-test',
        'Enter a valid time',
        (value: string | null | undefined) =>
          value === null || value === undefined || DateTime.fromFormat(value, 'HH:mm').isValid
      )
      .nullable()
      .notRequired(),
    completedBy: yup
      .object({
        id: yup.string().required(),
        fullName: yup.string().required(),
        email: yup.string().required(),
      })
      .default(undefined)
      .notRequired()
      .nullable(),
  });

export const TaskSchema = TaskSchemaGenerator();
export const EditTaskSchema = EditTaskSchemaGenerator();
export const EditCompletedTaskSchema = EditCompletedTaskSchemaGenerator();
